import { render, staticRenderFns } from "./TopicList.vue?vue&type=template&id=b87bc664&scoped=true"
import script from "./TopicList.vue?vue&type=script&lang=js"
export * from "./TopicList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87bc664",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b87bc664')) {
      api.createRecord('b87bc664', component.options)
    } else {
      api.reload('b87bc664', component.options)
    }
    module.hot.accept("./TopicList.vue?vue&type=template&id=b87bc664&scoped=true", function () {
      api.rerender('b87bc664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/circle/topic/TopicList.vue"
export default component.exports